module.exports = "<div class=\"rw-box\">\r\n  <ng-transclude></ng-transclude>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-box/rw-box.html
// module id = 2051
// module chunks = 0